import { render, staticRenderFns } from "./test-service-detail.vue?vue&type=template&id=00db357d&scoped=true"
import script from "./test-service-detail.vue?vue&type=script&lang=js"
export * from "./test-service-detail.vue?vue&type=script&lang=js"
import style0 from "./test-service-detail.vue?vue&type=style&index=0&id=00db357d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db357d",
  null
  
)

export default component.exports